import React from "react";
import Lottie from "react-lottie";
import "./Loader.css";
import * as animationData from "./Loader.json";

const Loader = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      <section className="main-lottey">
        <div className="Loader mx-auto">
          <Lottie options={defaultOptions} />
        </div>
      </section>
    </>
  );
};

export default Loader;
